(function (factory) {
    "use strict";

    if (typeof module === "object" && module.exports) {
        module.exports = factory;
    } else {
        factory(Highcharts);
    }
}(function (Highcharts) {
    var rel = Highcharts.relativeLength;

    Highcharts.wrap(Highcharts.seriesTypes.column.prototype, 'translate', function (proceed) {
        var options = this.options,
            topMargin = options.topMargin || 0,
            bottomMargin = options.bottomMargin || 0;

        proceed.call(this);

        var chart = this;
        // Replace H.each with Array.forEach
        this.points.forEach(function (point) {
            var shapeArgs = point.shapeArgs,
                w = shapeArgs.width,
                h = shapeArgs.height,
                x = shapeArgs.x,
                y = shapeArgs.y;

            // Get the radius
            var rTopLeft = rel(options.borderRadiusTopLeft || 0, w),
                rTopRight = rel(options.borderRadiusTopRight || 0, w),
                rBottomRight = rel(options.borderRadiusBottomRight || 0, w),
                rBottomLeft = rel(options.borderRadiusBottomLeft || 0, w);

            var p = point;
            // qma-specific: check whether there is data ahead
            // -->
            var hasDataAhead = false;
            if (rTopLeft || rTopRight) {
                for(var sIndex = 0; sIndex < p.series.index; sIndex++) {
                    var s = p.series.chart.series[sIndex];
                    if (s && s.visible && s.data[p.index] && s.data[p.index].y > 0) {
                        hasDataAhead = true;
                    }
                }
            } else if (rBottomRight || rBottomLeft) {
                for(var sIndex = p.series.index + 1; sIndex < p.series.chart.series.length; sIndex++) {
                    var s = p.series.chart.series[sIndex];
                    if (s && s.visible && s.data[p.index] && s.data[p.index].y > 0) {
                        hasDataAhead = true;
                    }
                }
            }
            // <-- qma-specifc ends
            // if there is no data ahead, draw the round corners
            if (!hasDataAhead && (rTopLeft || rTopRight || rBottomRight || rBottomLeft)) {
                var maxR = Math.min(w, h) / 2
                    
                if (rTopLeft > maxR) {
                    rTopLeft = maxR;
                }

                if (rTopRight > maxR) {
                    rTopRight = maxR;
                }

                if (rBottomRight > maxR) {
                    rBottomRight = maxR;
                }

                if (rBottomLeft > maxR) {
                    rBottomLeft = maxR;
                }

                // Preserve the box for data labels
                point.dlBox = point.shapeArgs;

                point.shapeType = 'path';
                point.shapeArgs = {
                    d: [
                        'M', x + rTopLeft, y + topMargin,
                        // top side
                        'L', x + w - rTopRight, y + topMargin,
                        // top right corner
                        'C', x + w - rTopRight / 2, y, x + w, y + rTopRight / 2, x + w, y + rTopRight,
                        // right side
                        'L', x + w, y + h - rBottomRight,
                        // bottom right corner
                        'C', x + w, y + h - rBottomRight / 2, x + w - rBottomRight / 2, y + h, x + w - rBottomRight, y + h + bottomMargin,
                        // bottom side
                        'L', x + rBottomLeft, y + h + bottomMargin,
                        // bottom left corner
                        'C', x + rBottomLeft / 2, y + h, x, y + h - rBottomLeft / 2, x, y + h - rBottomLeft,
                        // left side
                        'L', x, y + rTopLeft,
                        // top left corner
                        'C', x, y + rTopLeft / 2, x + rTopLeft / 2, y, x + rTopLeft, y,
                        'Z'
                    ]
                };
            }
        });
    });
}));